module.exports = __webpack_public_path__ + "media/images/japan/nav_3-022b92b3a7230f3830c314eda22c9f18.svg";